import React, { useState } from "react";
import { Row, Col, Card, Typography, Input, Button, Form, message } from "antd";
import styled, { keyframes } from "styled-components";
import { Link } from "react-router-dom";
import {
  DoubleLeftOutlined,
  PhoneOutlined,
  MailOutlined,
  HomeOutlined,
  SendOutlined,
  EnvironmentOutlined,
} from "@ant-design/icons";
import emailjs from "emailjs-com";
import Swal from "sweetalert2";
import Location3D from "../Loction3D/Location3D";

const { Title, Text } = Typography;

// Fade-in animation
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const ContactContainer = styled.div`
  margin: auto;
  margin-top: 90px;
  padding: 40px 20px;
  background: linear-gradient(
    90deg,
    rgb(3, 13, 51),
    rgb(0, 53, 55),
    rgb(0 0 0)
  );
  min-height: 100vh;
  color: #fff;
  animation: ${fadeIn} 1s ease-in-out;
`;

const ContactFormCard = styled(Card)`
  padding: 24px;
  border-radius: 10px;
  box-shadow: 0px 0px 15px rgb(255 255 255 / 37%);
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  color: #fff;
  border: none;
`;

const StyledButton = styled(Button)`
  background: linear-gradient(45deg, #46484b, #75aeff);
  color: #fff;
  border-radius: 25px;
  height: 45px;
  font-weight: bold;
  box-shadow: 0 4px 10px rgba(255, 75, 43, 0.4);
  transition: all 0.3s ease-in-out;
  &:hover {
    background: linear-gradient(45deg, #ff4b2b, #ff416c);
    transform: scale(1.05);
  }
`;

const AddressWrapper = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: flex-start;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 4px;
  }

  label {
    color: white;
    font-size: 18px;
    // font-family: monospace;
    word-break: break-word;
  }

  .address-title {
    display: flex;
    align-items: center;
    font-weight: 500;
    flex-shrink: 0;
    white-space: nowrap;
  }

  .address-text {
    flex: 1;
    min-width: 0;
    white-space: normal;
  }
`;

const Contact = () => {
  const [form] = Form.useForm();
  const [loading, setloading] = useState(false);
  const [isFormTouched, setIsFormTouched] = useState(false);

  // first_name last_name email mobileNoo message
  // const handleFormChange = (_, allValues) => {
  //   const hasValue = Object.values(allValues).some((value) => !!value);
  //   setIsFormTouched(hasValue);
  // };
  const handleFormChange = (_, allValues) => {
    const { firstName, lastName, email, mobileNoo, message } = allValues;

    const isValid =
      firstName?.trim() &&
      lastName?.trim() &&
      email?.trim() &&
      message?.trim() &&
      /^[0-9]{10}$/.test(mobileNoo);

    setIsFormTouched(isValid);
  };

  const sendEmail = (values) => {
    setloading(true);
    const templateParams = {
      first_name: values.firstName,
      last_name: values.lastName,
      email: values.email,
      mobileNoo: values.mobileNoo,
      message: values.message,
    };

    emailjs
      .send(
        "service_ubx1xf9", // Replace with your EmailJS Service ID
        "template_hvsxryj", // Replace with your EmailJS Template ID
        templateParams,
        "LqxcBlSXzD3ZwIOUC" // Replace with your EmailJS User ID (Public Key)
      )
      .then(
        (response) => {
          Swal.fire({
            icon: "success",
            title: "Message Sent Successfully!",
            text: "Your message has been sent. We will get back to you shortly.",
            confirmButtonText: "Okay",
          });
          form.resetFields();
          setIsFormTouched(false);
          setloading(false);
        },
        (error) => {
          Swal.fire({
            icon: "error",
            title: "Failed to Send Message",
            text: "There was an issue sending your message. Please try again.",
            confirmButtonText: "Retry",
          });
          // console.error("EmailJS Error:", error);
          setloading(false);
        }
      );
  };

  return (
    <ContactContainer>
      <Row>
        <Col xs={24} md={24} lg={2} xl={2}></Col>
        <Col xs={24} md={24} lg={20} xl={20}>
          <Text
            strong
            style={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              marginBottom: 20,
            }}
          >
            <Link
              to="/"
              style={{ color: "white", display: "flex", alignItems: "center" }}
            >
              <DoubleLeftOutlined style={{ marginRight: 8 }} />
              Back to Home
            </Link>
          </Text>
        </Col>
        <Col xs={24} md={24} lg={2} xl={2}></Col>
      </Row>

      <Row gutter={[16, 16]}>
        <Col xs={24} md={24} lg={1} xl={2}></Col>
        <Col xs={24} md={24} lg={12} xl={8}>
          <Title
            level={2}
            style={{ color: "#00ff99", fontSize: "clamp(20px, 5vw, 32px)" }}
          >
            Contact us
          </Title>
          <Title
            level={4}
            style={{ color: "white", fontSize: "clamp(14px, 4vw, 18px)" }}
          >
            {/* We strive to deliver accurate, trustworthy, and engaging content to
            our users... */}
            We're just getting started and would love to connect with partners,
            investors, vendors, and future customers.
          </Title>
          <br />

          {/* <div style={{ marginTop: 20, display: "flex", alignItems: "center" }}>
            <Text
              strong
              style={{ color: "#00ff99", fontSize: "clamp(14px, 3.5vw, 16px)" }}
            >
              <PhoneOutlined
                style={{
                  fontSize: "clamp(14px, 4vw, 20px)",
                  marginRight: 10,
                  transform: "rotate(105deg)",
                }}
              />{" "}
              CALL US: &nbsp;
            </Text>
            <Title
              level={4}
              style={{
                color: "white",
                fontSize: "clamp(14px, 4vw, 18px)",
                margin: 0,
              }}
            >
              <a
                href="tel:+9284382353"
                style={{
                  color: "white",
                }}
              >
                +919284382353
              </a>
            </Title>
          </div>

          <div style={{ marginTop: 20, display: "flex", alignItems: "center" }}>
            <Text
              strong
              style={{ color: "#00ff99", fontSize: "clamp(14px, 3.5vw, 16px)" }}
            >
              <MailOutlined
                style={{ fontSize: "clamp(14px, 4vw, 20px)", marginRight: 10 }}
              />
              EMAIL: &nbsp;
            </Text>
            <a
              href="mailto:nexuswealthservices@gmail.com"
              style={{ color: "white", textDecoration: "none" }}
            >
              <Title
                level={4}
                style={{
                  color: "white",
                  fontSize: "clamp(14px, 4vw, 18px)",
                  margin: 0,
                }}
              >
                nexuswealthservices@gmail.com
              </Title>
            </a>
          </div>

          <div
            style={{
              marginTop: 20,
              display: "flex",
              alignItems: "flex-start",
              flexWrap: "wrap",
            }}
          >
            <Text
              strong
              style={{
                color: "#00ff99",
                fontSize: "clamp(14px, 3.5vw, 16px)",
                display: "flex",
                alignItems: "center",
                flexShrink: 0,
                marginRight: 10,
              }}
            >
              <HomeOutlined
                style={{ fontSize: "clamp(14px, 4vw, 20px)", marginRight: 10 }}
              />
              ADDRESS:
            </Text>
            <Title
              level={4}
              style={{
                color: "white",
                fontSize: "clamp(14px, 4vw, 18px)",
                margin: 0,
                wordBreak: "break-word",
                whiteSpace: "normal",
                maxWidth: "100%",
              }}
            >
              365/B Plot No-1, Mehul Garden Opposite to Priya Darshani Colony,
              Karvir Kolhapur, Maharashtra, Uchagaon 416005
            </Title>
          </div> */}
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={24}>
              <PhoneOutlined
                style={{
                  marginRight: 8,
                  color: "white",
                  fontSize: 18,
                  transform: "rotate(105deg)",
                }}
              />
              <Text strong style={{ color: "white", fontSize: 18 }}>
                Call us:
              </Text>
              {/* <br /> */} &nbsp;
              <Text>
                <a
                  href="tel:+919284382353"
                  style={{
                    color: "white",
                    fontSize: 18,
                  }}
                >
                  +919284382353
                </a>
              </Text>
            </Col>

            <Col xs={24} sm={24}>
              <MailOutlined
                style={{ marginRight: 8, color: "white", fontSize: 18 }}
              />
              <Text strong style={{ color: "white", fontSize: 18 }}>
                Email:{" "}
              </Text>
              {/* <br /> */}&nbsp;
              <Text>
                <a
                  href="mailto:nexuswealthservices@gmail.com"
                  style={{
                    color: "white",
                    fontSize: 18,
                    textDecoration: "none",
                  }}
                >
                  nexuswealthservices@gmail.com
                </a>
              </Text>
            </Col>

            <Col xs={24} sm={24}>
              <AddressWrapper>
                <label className="address-title">
                  <EnvironmentOutlined
                    style={{
                      marginRight: 8,
                      color: "white",
                      fontSize: 17,
                      marginTop: 4,
                    }}
                  />
                  Address:
                </label>

                <label className="address-text">
                  365/B Plot No-1, Mehul Garden, Opposite to Priya Darshani
                  Colony, Karvir Kolhapur Maharashtra, Uchagaon 416005.
                </label>
              </AddressWrapper>
            </Col>
          </Row>
        </Col>

        <Col xs={24} md={24} lg={11} xl={12}>
          <ContactFormCard>
            <Title level={3} style={{ color: "white" }}>
              Contact Form
            </Title>
            <Form
              form={form}
              layout="vertical"
              onFinish={sendEmail}
              onValuesChange={handleFormChange}
            >
              <Row gutter={16}>
                <Col xs={24} md={12}>
                  <Form.Item
                    name="firstName"
                    label={<span style={{ color: "white" }}>First name</span>}
                    rules={[
                      {
                        required: true,
                        message: "Please enter your first name!",
                        max: 15,
                        message: "First name cannot exceed 15 characters",
                      },
                    ]}
                  >
                    <Input placeholder="First name" />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    name="lastName"
                    label={<span style={{ color: "white" }}>Last name</span>}
                    rules={[
                      {
                        required: true,
                        message: "Please enter your last name!",
                        max: 15,
                        message: "Last name cannot exceed 15 characters",
                      },
                    ]}
                  >
                    <Input placeholder="Last name" />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col xs={24} md={12}>
                  <Form.Item
                    name="email"
                    rules={[
                      {
                        required: true,
                        type: "email",
                        message: "The input is not valid E-mail!",
                      },
                    ]}
                    label={<span style={{ color: "white" }}>Email</span>}
                  >
                    <Input placeholder="nexus@company.com" />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    name="mobileNoo"
                    label={<span style={{ color: "white" }}>Phone number</span>}
                    rules={[
                      {
                        required: true,
                        message: "Please enter your phone number!",
                      },
                      {
                        pattern: /^[0-9]{10}$/,
                        message: "Phone number must be 10 digits!",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Phone number"
                      onKeyPress={(e) => {
                        if (!/^[0-9]$/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Form.Item
                name="message"
                label={<span style={{ color: "white" }}>Description</span>}
                rules={[
                  {
                    required: true,
                    message: "Please enter your message!",
                  },
                ]}
              >
                <Input.TextArea rows={4} placeholder="How Can We Help?" />
              </Form.Item>
              <label style={{color:"white", fontSize:"16px",}}>
                {" "}
                Please Enter First name, Last name, Email, Mobile Number, and Message, & ensure the Submit button is active{" "}
              </label>
              <br />
              <br />
              <StyledButton
                type="primary"
                htmlType="submit"
                loading={loading}
                block
                disabled={!isFormTouched}
              >
                {loading ? `${(loading, "Loading...")}` : "Send Message"}
                {!loading && <SendOutlined />}
              </StyledButton>
            </Form>
          </ContactFormCard>
        </Col>
        <Col xs={24} md={24} lg={2} xl={2}></Col>
      </Row>
      <br />
      <br />
      <Row>
        <Col xs={24} md={24} lg={24} xl={24}>
          {/* <Location3D /> */}
        </Col>
      </Row>
    </ContactContainer>
  );
};

export default Contact;
